// packages
import dayjs from 'dayjs';

// components
import { Fragment } from 'react/jsx-runtime';
import { Box, styled, Typography } from '@mui/material';
import KidsTableRow from './KidsTableRow';

// hooks
import { useDateNavigationStore } from 'components/shared/DateNavigation/DateNavigation.stores';

// types
import { KidsRatioOverviewResponse, KidsRatioResponse } from 'generated';

// constants
import { CARD_WIDTH } from 'constants/widths';
import { WHITE } from 'constants/colors';

type Props = {
  ratios: KidsRatioOverviewResponse;
};

const times = ['10:30', '15:30'];

const TableCell = styled('td')`
  height: 50px;
`;

export default function KidsTable({ ratios }: Props) {
  const dateNavigationPeriod = useDateNavigationStore(({ period }) => period);
  const isWorkweek = dateNavigationPeriod === 'workweek';
  const weekLength = isWorkweek ? 5 : 7;

  function getRatiosByWeekDay(arr): Record<number, KidsRatioResponse[]> {
    return arr?.reduce((acc, cur) => {
      const dayOfWeek = dayjs(cur.date).isoWeekday();
      acc[dayOfWeek] = acc[dayOfWeek] || [];
      acc[dayOfWeek].push(cur);
      return acc;
    }, {});
  }

  return (
    <>
      <tr>
        <TableCell
          sx={{
            verticalAlign: 'top',
            position: 'sticky',
            left: 0,
            zIndex: 40,
            background: `linear-gradient(90deg, ${WHITE} 70%, transparent)`,
            padding: '0 8px'
          }}
        >
          <Typography fontSize="12px" py={1} sx={{ width: `${CARD_WIDTH}px` }}>
            Adviespaneel
          </Typography>
        </TableCell>
        {Array.from({ length: weekLength }).map((_, index) => (
          <td key={index}>
            <Box display="flex" fontSize="12px" py={1}>
              {times.map((time) => (
                <Box key={time} flex="1" textAlign="center">
                  {time}
                </Box>
              ))}
            </Box>
          </td>
        ))}
      </tr>
      {ratios.organizationalUnitRatios &&
        ratios.organizationalUnitRatios.length > 1 &&
        [...ratios.organizationalUnitRatios]
          .sort(function (a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          })
          .map((ratio) => (
            <Fragment key={ratio.organizationalUnitId}>
              <KidsTableRow
                key={ratio.organizationalUnitId}
                name={ratio.name}
                ratios={getRatiosByWeekDay(ratio.ratios)}
                times={times}
                isWorkweek={isWorkweek}
              />
              <tr className="empty">
                <td></td>
              </tr>
            </Fragment>
          ))}
      <KidsTableRow
        name={
          ratios.organizationalUnitRatios &&
          ratios.organizationalUnitRatios.length == 1
            ? ratios.organizationalUnitRatios[0].name
            : 'Gezamenlijk rooster'
        }
        ratios={getRatiosByWeekDay(ratios.totalRatios)}
        times={times}
        isWorkweek={isWorkweek}
      />
    </>
  );
}
